import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectRole = (store: StoreSchema) => store.newUserRole.role
